import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/app/hooks";
import { selectShops } from "@/features/shell/legacySelectors";
import { ModalShell, StatusBadge } from "@/shared/layout";
import { Modal } from "@/shared/ui";
import { ArrowRight, Code2 } from "@/shared/ui/icons";
import { useShellDialogs } from "../dialogs";
import { notificationMeta, notificationPayload } from "./codes";
import { useNotificationRedirect } from "./useNotificationRedirect";

export function NotificationDetailModal() {
  const { t } = useTranslation();
  const dialogs = useShellDialogs();
  const shops = useAppSelector(selectShops);
  const redirect = useNotificationRedirect();
  const notification = dialogs.notificationDetail;
  if (!notification) return null;
  const meta = notificationMeta(notification.code);
  // string: i codici hanno solo "danger" | "info", il ramo "warning" resta per fedelta' al markup legacy
  const status: string = meta.status || "neutral";
  const tone = status === "danger" ? "error" : status === "warning" ? "warning" : "info";
  const back = () => dialogs.closeNotificationDetail();
  const viewIssue = () => {
    redirect(notification);
    // il legacy chiudeva il dettaglio senza riaprire la lista
    dialogs.dismissNotificationDetail();
  };
  const footer = (
    <>
      <button type="button" className="btn btn-secondary btn-sm" onClick={back}>
        Back
      </button>
      {meta.redirect && (
        <button type="button" className="btn btn-primary btn-sm gap-2" onClick={viewIssue}>
          {t("notificationsModal.viewIssue")}
          <ArrowRight className="size-4" aria-hidden="true" />
        </button>
      )}
    </>
  );
  return (
    <Modal
      id="notification-detail-modal"
      open
      onOpenChange={(open) => {
        if (!open) back();
      }}
      title={t(`notificationsModal.${meta.title}`)}
    >
      <ModalShell
        title={t(`notificationsModal.${meta.title}`)}
        description={
          <span
            dangerouslySetInnerHTML={{
              __html: t(`notificationsModal.${meta.message}`, notificationPayload(notification, shops)),
            }}
          />
        }
        onClose={back}
        footer={footer}
      >
        <div className="dw-modal-stack">
          <StatusBadge tone={tone}>{status}</StatusBadge>
          <section className="dw-technical-detail">
            <div>
              <Code2 aria-hidden="true" />
              <strong>Technical detail</strong>
            </div>
            <pre>{JSON.stringify(notification.detail, null, 2)}</pre>
          </section>
        </div>
      </ModalShell>
    </Modal>
  );
}
